import { render } from "./TeamAssignmentEstimator.vue?vue&type=template&id=18946b6b&scoped=true"
import script from "./TeamAssignmentEstimator.vue?vue&type=script&lang=js"
export * from "./TeamAssignmentEstimator.vue?vue&type=script&lang=js"

import "./TeamAssignmentEstimator.vue?vue&type=style&index=0&id=18946b6b&scoped=true&lang=css"
import "./TeamAssignmentEstimator.vue?vue&type=style&index=1&id=18946b6b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18946b6b"]])

export default __exports__